var _defs, _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gruppe_2410",
    "data-name": "Gruppe 2410",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-6664 -614 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-1 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-miterlimit: 10;\n        stroke-width: 1.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2407",
    "data-name": "Gruppe 2407",
    transform: "translate(-6668 -833.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_169",
    "data-name": "Pfad 169",
    className: "cls-1",
    d: "M52.8,265a3.159,3.159,0,0,1-3.2,3.2H19.2A3.159,3.159,0,0,1,16,265V234.6a3.159,3.159,0,0,1,3.2-3.2H49.6a3.159,3.159,0,0,1,3.2,3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_170",
    "data-name": "Pfad 170",
    className: "cls-1",
    d: "M16,245.8h6.4l3.2-4.8,3.2,4.8,3.2-7.2,4.8,15.2,4-19.2L44,245.8h8.8"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_38",
    "data-name": "Linie 38",
    className: "cls-1",
    y2: 1.6,
    transform: "translate(22.4 263.4)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_39",
    "data-name": "Linie 39",
    className: "cls-1",
    y2: 1.6,
    transform: "translate(32 263.4)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_40",
    "data-name": "Linie 40",
    className: "cls-1",
    y2: 1.6,
    transform: "translate(41.6 263.4)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_41",
    "data-name": "Linie 41",
    className: "cls-1",
    y2: 4.8,
    transform: "translate(27.2 260.2)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_42",
    "data-name": "Linie 42",
    className: "cls-1",
    y2: 4.8,
    transform: "translate(36.8 260.2)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_43",
    "data-name": "Linie 43",
    className: "cls-1",
    y2: 4.8,
    transform: "translate(46.4 260.2)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1328",
    "data-name": "Rechteck 1328",
    className: "cls-2",
    width: 60,
    height: 60,
    transform: "translate(-6664 -614)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter4);
export default __webpack_public_path__ + "static/media/filter4.60cda6f3e5473d27aae799f98685cc70.svg";
export { ForwardRef as ReactComponent };